var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureIconwithcircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F4F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 38H52L49 34L46 38ZM46 42H52L49 46L46 42Z",
    fill: "#FFCEA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 28H35V52H29C28.7348 52 28.4804 51.8946 28.2929 51.7071C28.1054 51.5196 28 51.2652 28 51V29C28 28.7348 28.1054 28.4804 28.2929 28.2929C28.4804 28.1054 28.7348 28 29 28Z",
    fill: "#FF7900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 28H43C43.2652 28 43.5196 28.1054 43.7071 28.2929C43.8946 28.4804 44 28.7348 44 29V51C44 51.2652 43.8946 51.5196 43.7071 51.7071C43.5196 51.8946 43.2652 52 43 52H37V28Z",
    fill: "#FFC0D0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIconwithcircle);
export default __webpack_public_path__ + "static/media/FeatureIconwithcircle.835df8b0fc32fa91093fbc8747cf27a1.svg";
export { ForwardRef as ReactComponent };